import { AuditLogService } from "./features/audit-log/audit-log-service";
import { AuditLogStore } from "./features/audit-log/audit-log-store";
import { AuditLogViewModel } from "./features/audit-log/audit-log-viewmodel";
import { LogStore } from "./features/log/log-store";
import { LogViewModel } from "./features/log/log-view-model";
import { LoginViewModel } from "./features/login/login-viewmodel";
import { OAuthService } from "./features/oauth/oauth-service";
import { OAuthStore } from "./features/oauth/oauth-store";
import { OAuthViewModel } from "./features/oauth/oauth-viewmodel";
import { OperationsService } from "./features/operations/operations-service";
import { OperationsStore } from "./features/operations/operations-store";
import { OperationsViewModel } from "./features/operations/operations-viewmodel";
import { RegistrationService } from "./features/registrations/registrations-service";
import { RegistrationsStore } from "./features/registrations/registrations-store";
import { RegistrationsViewModel } from "./features/registrations/registrations-viewmodel";
import { UserIdStore } from "./features/user-id/user-id-store";
import { UserIdViewModel } from "./features/user-id/user-id-viewmodel";
import { isSessionStorageSupported } from "./utils/sessionstorage-check";
import { ViewModelContainer } from "./viewmodel/viewmodel";
/**
 * Function is called on app launch.
 * It checks for basic browser features necessary for Console to run.
 * It initializes ViewModel provider with storages and services accordingly.
 * */
export function init() {
    if (!isSessionStorageSupported()) {
        return new Error("LocalStorage is not supported.");
    }
    // register view model instances
    registerViewModelInstances(ViewModelContainer.getInstance());
}
function registerViewModelInstances(container) {
    const logStore = new LogStore();
    container.registerViewModel(LogViewModel, () => {
        return new LogViewModel(logStore);
    });
    container.registerViewModel(LoginViewModel, () => {
        return new LoginViewModel();
    });
    container.registerViewModel(OAuthViewModel, () => {
        return new OAuthViewModel(OAuthStore.getInstance(), OAuthService.getInstance(logStore));
    });
    container.registerViewModel(UserIdViewModel, () => {
        const store = new UserIdStore();
        return new UserIdViewModel(store);
    });
    container.registerViewModel(RegistrationsViewModel, () => {
        const store = new RegistrationsStore();
        const service = new RegistrationService(store, logStore);
        return new RegistrationsViewModel(store, service);
    });
    container.registerViewModel(OperationsViewModel, () => {
        const store = new OperationsStore();
        const service = new OperationsService(store, logStore);
        return new OperationsViewModel(store, service);
    });
    container.registerViewModel(AuditLogViewModel, () => {
        const store = new AuditLogStore();
        const service = new AuditLogService(store, logStore);
        return new AuditLogViewModel(store, service);
    });
}
